/**
* Components are lazy-loaded - See "Grouping Components in the Same Chunk"
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/
/* eslint-disable global-require */

const leaderboard = {
  	index: 		r => require.ensure([], () => r(require('./components/leader')), 'recipient-bundle'),
	edit: 	r => require.ensure([], () => r(require('./components/edit')), 	'recipient-bundle'),
	LeaderboardNew: 	r => require.ensure([], () => r(require('./components/leaderboard_new')), 	'recipient-bundle'),
};


export default [
    {
		name: 'reports.leaderboard',
		path: '/reports/leaderboard',
		component: leaderboard.index,
    },
    {
		name: 'leaderboard.edit',
		path: '/leaderboard/:id',
		component: leaderboard.edit,
    },
    {
		name: 'leaderboard',
		path: '/leaderboard',
		component: leaderboard.LeaderboardNew,
    },
]





// WEBPACK FOOTER //
// ./src/app/leaderboard/routes.js